import { PermissionGuard } from './../guards/permission.guard';
import { AuthGuard } from './../guards/auth.guard';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { SharedModule } from './shared.module';
import { BbTableModule } from './bb-table.module';

import { ProjectStatsListComponent } from '../components/analytics/project/project-stats-list.component';
import { ProjectStatsComponent } from '../components/analytics/project/project-stats.component';
import { ProjectStatsPerformanceComponent } from './../components/analytics/project/project-stats-performance.component';
import { AnalyticsComponent } from '../components/analytics/analytics.component';
import { ReportListComponent } from '../components/analytics/reports/report-list.component';
import { ReportDetailsComponent } from '../components/analytics/reports/report-details.component';
import { ReportDetailsContentsComponent } from '../components/analytics/reports/report-details-contents.component';
import { ReportDetailsScheduleComponent } from '../components/analytics/reports/report-details-schedule.component';
import { ReportColumnsComponent } from '../components/analytics/reports/report-columns.component';
import { RealtimeComponent } from '../components/analytics/realtime-audience/realtime-audience.component';
import { RealtimeAudienceGraphComponent } from './../components/analytics/realtime-audience/realtime-audience-graph.component';
import { RealtimeAudienceMapComponent } from './../components/analytics/realtime-audience/realtime-audience-map.component';
import { RealtimeAudienceTickerComponent } from './../components/analytics/realtime-audience/realtime-audience-ticker.component';
import { RealtimeViewSessionsComponent } from './../components/analytics/realtime-audience/realtime-audience-view-sessions.component';
import { StatsProgressComponent } from '../components/shared/stats-progress/stats-progress.component';
import { RealtimeAudienceToplistComponent } from './../components/analytics/realtime-audience/realtime-audience-toplist.component';

import { BbAnalyticsMenuComponent } from '../components/analytics/bb-analytics-menu.component';
import { AnalyticsDashboardComponent } from './../components/analytics/analytics/analytics-dashboard.component';
import { StatisticsComponent } from '../components/analytics/statistics/statistics.component';

import { DefaultService } from '../services/default.service';

const moduleRoutes: Routes = [
	{
		path: 'analytics',
		canActivate: [AuthGuard],
		component: AnalyticsComponent,
		children: [
			{
				path: 'statistics', component: AnalyticsDashboardComponent, data: {
					permissions: ['statistics'],
					class: 'has-sidebar has-header'
				}, canActivate: [PermissionGuard]
			},
			{ path: 'statistics/:id', redirectTo: 'statistics/mediaclip/:id', pathMatch: 'full' },
			{
				path: 'statistics/:type/:id', component: AnalyticsDashboardComponent, data: {
					permissions: ['statistics'],
					class: 'has-sidebar has-header'
				}, canActivate: [PermissionGuard]
			},
			{ path: 'reports', component: ReportListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'reports/:id', redirectTo: 'reports/:id/contents', pathMatch: 'full' },
			{ path: 'reports/:id/:tab', component: ReportDetailsComponent },
			{ path: 'projects', component: ProjectStatsListComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'project/:id', redirectTo: 'project/:id/performance', pathMatch: 'full' },
			{ path: 'project/:id/:tab', component: ProjectStatsComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'ad-statistics', component: StatisticsComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'ad-statistics/:mediaclipId', component: StatisticsComponent, data: { class: 'has-sidebar has-header' } },
			{ path: 'realtime', component: RealtimeComponent, data: { class: 'has-sidebar has-header' } }
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forChild(moduleRoutes),
		SharedModule,
		CommonModule,
		BbTableModule
	],
	declarations: [
		StatsProgressComponent,
		ProjectStatsListComponent,
		ProjectStatsComponent,
		ProjectStatsPerformanceComponent,
		ReportListComponent,
		ReportDetailsComponent,
		ReportDetailsContentsComponent,
		ReportDetailsScheduleComponent,
		ReportColumnsComponent,
		AnalyticsComponent,
		RealtimeComponent,
		RealtimeAudienceTickerComponent,
		RealtimeViewSessionsComponent,
		RealtimeAudienceGraphComponent,
		RealtimeAudienceMapComponent,
		RealtimeAudienceToplistComponent,
		AnalyticsDashboardComponent,
		StatisticsComponent
	],
	exports: [
		StatsProgressComponent,
		ProjectStatsListComponent,
		ProjectStatsComponent,
		ProjectStatsPerformanceComponent,
		ReportListComponent,
		ReportDetailsComponent,
		ReportDetailsContentsComponent,
		ReportDetailsScheduleComponent,
		ReportColumnsComponent,
		AnalyticsComponent,
		RealtimeComponent,
		RealtimeAudienceTickerComponent,
		RealtimeViewSessionsComponent,
		RealtimeAudienceGraphComponent,
		RealtimeAudienceMapComponent,
		RealtimeAudienceToplistComponent,
		BbAnalyticsMenuComponent
	],
	providers: [
		BbAnalyticsMenuComponent,
		DefaultService
	]
})
export class AnalyticsModule {

}
